/**
 * NIGHTBOUND - title screen.
 *
 * The first thing the player sees. Deliberately spare: a threshold, a promise,
 * and one way in.
 */

import { Link } from 'react-router-dom'
import { Logo } from '../components/Logo'
import { Panel } from '../components/ui'

export function TitleScreen() {
  return (
    <div className="relative flex min-h-[100svh] flex-col">
      <div aria-hidden className="nb-room absolute inset-0 -z-10" />
      <div aria-hidden className="nb-vignette absolute inset-0 -z-10" />

      <main className="mx-auto flex w-full max-w-3xl flex-1 flex-col items-center justify-center gap-10 px-6 py-16 text-center">
        <div className="nb-emerge space-y-6">
          <Logo size="lg" tagline="A dark creature-raising RPG" />
          <p className="mx-auto max-w-md font-display text-sm leading-relaxed text-bone-300/90">
            Something followed you down. It is small, it is frightened, and it has decided that you
            are the only safe thing left in the world.
          </p>
          <p className="mx-auto max-w-md text-xs leading-relaxed text-ash-400">
            Keep it fed, clean, rested and sane. It will not thank you, but it will survive the
            dark because of you.
          </p>
        </div>

        <Panel className="w-full max-w-md p-5" grain>
          <div className="space-y-3">
            <Link
              to="/enter"
              className="inline-flex w-full select-none items-center justify-center gap-2 rounded-[3px] border border-ember-600/70 bg-ember-500/15 px-6 py-3 text-sm font-semibold uppercase tracking-[0.16em] text-ember-400 transition-colors hover:bg-ember-500/25 active:bg-ember-500/30"
            >
              Enter the shelter
            </Link>
            <p className="text-[11px] leading-relaxed text-ash-500">
              Installs like an app and keeps playing offline. Your creature keeps living while you
              are away.
            </p>
          </div>
        </Panel>

        <p className="nb-label text-[8px] text-ash-600">v0.1.0 · first playable milestone</p>
      </main>
    </div>
  )
}
